import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { sendTrackingInfo, ModalInformation } from '@panel/commons';

function OnHoldToOnCreditsNoEcomYes(props) {
  const { onClickCancel, isInmobiliaria, postingId } = props;
  const { t } = useTranslation();

  useEffect(() => {
    const txt = `'Republicar Aviso en Espera_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}-Intencion`;
    sendTrackingInfo('Mis avisos', txt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickAction = () => {
    const txt = `Republicar Aviso en Espera sin credito_Adquirir Credito_${
      isInmobiliaria ? 'Inmobiliaria' : 'Particular'
    }`;
    sendTrackingInfo('Mis avisos', txt);
    onClickCancel();
  };

  const handleClickCancel = () => {
    const txt = `Republicar Aviso en Espera sin credito_Cancelar_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`;
    sendTrackingInfo('Mis avisos', txt);
    onClickCancel();
  };

  const url = isInmobiliaria
    ? `..${t('panel.url.ecommerce.professional')}?idPosting=${postingId}`
    : `..${t('panel.url.ecommerce.particular')}?idPosting=${postingId}`;

  return (
    <ModalInformation
      onClickAction={handleClickAction}
      onClickCancel={handleClickCancel}
      onClickOutside={handleClickCancel}
      title={t('panel.modal.OnHoldToOn.title')}
      message={t('panel.modal.OnHoldToOn.subtitle')}
      ctaCancel={t('panel.modal.cta.cancel')}
      urlLink={url}
      ctaAnchor={t('panel.modal.cta.buyCredits')}
    />
  );
}

export { OnHoldToOnCreditsNoEcomYes };
